import axios from "axios";
import { Button, Popup, Scheduler, SelectBox, Toolbar } from "devextreme-react";
import { ToolbarItem } from "devextreme-react/popup";
import { Resource, View } from "devextreme-react/scheduler";
import { Item } from "devextreme-react/toolbar";
import ArrayStore from "devextreme/data/array_store";
import CustomStore from "devextreme/data/custom_store";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission } from "../../../utils/hasPermission";
import { PERM } from "../../../utils/permissions";
import { updateWorkRecord } from "./Redux/workRecord";
import ScheduleForm from "./ScheduleForm";
import WorkRecordForm from "./WorkRecordForm";
import DataSource from "devextreme/data/data_source";
import TimeCell from "./TimeCell";
import DataCell from "./DataCell";

export default function SchedulerComponent(props) {
  const {
    resourceDataSource,
    // currentEmployeeNo,
    currentEmployee,
    // setCurrentEmployeeNo,
    setCurrentEmployee,
    schedulerRef,
  } = props;

  // const schedulerRef = useRef(null);
  const descriptionRef = useRef(null);

  // const workRecordRef = useRef(null);
  const classifWorkSelectBoxRef = useRef(null);
  const projectDropDownBoxRef = useRef(null);
  const taskDropDownBoxRef = useRef(null);
  const detailedTaskDropDownBoxRef = useRef(null);
  const subjectTextBoxRef = useRef(null);

  const userInfo = useSelector((state) => state.userInfo);
  const canSeeMgrTab = hasPermission(userInfo.permissions, PERM.WR_MGR_TAB);
  const workRecord = useSelector((state) => state.workRecord);

  const [dataSource, setDataSource] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [appointmentData, setAppointmentData] = useState(null);

  const [employeeDataSource, setEmployeeDataSource] = useState(null);
  // const [currentEmployeeNo, setCurrentEmployeeNo] = useState(
  //   userInfo.employeeNo
  // );

  const dispatch = useDispatch();
  // const workRecord = useSelector((state) => state.workRecord);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee?div=${userInfo.div}`
      )
      .then((result) => {
        // setEmployeeDataSource(
        //   new ArrayStore({
        //     data: result.data,
        //     key: "employeeNo",
        //   })
        // );
        setEmployeeDataSource(
          new DataSource({
            store: {
              type: "array",
              data: result.data,
              key: "employeeNo",
            },
            group: "div",
          })
        );
      });
  }, []);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "id",
        load: async () => {
          try {
            const result = await axios.get(
              // `${process.env.REACT_APP_BECCO_API_URL}/api/workR?employeeNo=${userInfo.employeeNo}`
              // `${process.env.REACT_APP_BECCO_API_URL}/api/workR?employeeNo=${currentEmployeeNo}`
              `${process.env.REACT_APP_BECCO_API_URL}/api/workR?employeeNo=${currentEmployee.employeeNo}`
            );

            return result.data;
          } catch (error) {
            console.log(error);
          }
        },
        insert: async (values) => {
          try {
            await axios.post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/workR`,
              values
            );
          } catch (error) {
            console.log(error);
          }
        },
        update: async (key, values) => {
          try {
            await axios.put(
              `${process.env.REACT_APP_BECCO_API_URL}/api/workR/${key}`,
              values
            );
          } catch (error) {
            console.error(error);
          }
        },
        remove: async (key) => {
          try {
            await axios.delete(
              `${process.env.REACT_APP_BECCO_API_URL}/api/workR/${key}`
            );
          } catch (error) {
            console.error(error);
          }
        },
      })
    );
    // }, [currentEmployeeNo]);
  }, [currentEmployee.employeeNo]);

  const onValueChanged = (e) => {
    // setCurrentEmployeeNo(e.value.employeeNo);
    setCurrentEmployee({
      ...currentEmployee,
      employeeNo: e.value.employeeNo,
      div: e.value.div,
    });

    schedulerRef.current.instance.repaint();
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.name} (${item.employeeNo})`;
    } else {
      return null;
    }
  };

  const appointmentRender = (model) => {
    return (
      <React.Fragment>
        <i>{`[${
          model.appointmentData.contrNo
            ? model.appointmentData.contrNo
            : model.appointmentData.classifWork == 2
            ? `DW`
            : `OTHER`
        }]`}</i>
        <p
          style={{
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis", // Optional: adds '...' if the text still overflows the appointment block
            wordBreak: "break-word", // Optional: forces long words to break
            lineHeight: "1.2em",
          }}
        >
          {model.appointmentData.subject}
        </p>
      </React.Fragment>
    );
  };

  const onAppointmentFormOpening = (e) => {
    e.cancel = true;

    if (typeof e.appointmentData.classifWork == "undefined") {
      dispatch(
        updateWorkRecord({
          classifWork: null,
          contrNo: null,
          quotNo: null,
          codeNo: null,
          SEQ: null,
          subject: null,
          descr: null,
          startDate: e.appointmentData.startDate,
        })
      );
    } else {
      dispatch(
        updateWorkRecord({
          classifWork: e.appointmentData.classifWork,
          contrNo:
            typeof e.appointmentData.contrNo == "string"
              ? Array.of(e.appointmentData.contrNo)
              : e.appointmentData.contrNo,
          quotNo: e.appointmentData.quotNo,
          codeNo:
            typeof e.appointmentData.codeNo == "string"
              ? Array.of(e.appointmentData.codeNo)
              : e.appointmentData.codeNo,
          SEQ: e.appointmentData.SEQ,
          subject: e.appointmentData.subject,
          descr: e.appointmentData.descr,
          startDate: e.appointmentData.startDate,
        })
      );
    }

    setAppointmentData(e.appointmentData);
    setPopupVisible(true);
  };

  const onClick = () => {
    if (!workRecord.classifWork) {
      classifWorkSelectBoxRef.current.instance.option(
        "validationStatus",
        "invalid"
      );

      return;
    }

    if (!workRecord.contrNo) {
      if (!projectDropDownBoxRef.current.props.disabled) {
        projectDropDownBoxRef.current.instance.option(
          "validationStatus",
          "invalid"
        );

        return;
      }
    }

    if (!workRecord.codeNo) {
      if (!taskDropDownBoxRef.current.props.disabled) {
        taskDropDownBoxRef.current.instance.option(
          "validationStatus",
          "invalid"
        );

        return;
      }
    }

    if (!workRecord.SEQ) {
      if (!detailedTaskDropDownBoxRef.current.props.disabled) {
        detailedTaskDropDownBoxRef.current.instance.option(
          "validationStatus",
          "invalid"
        );

        return;
      }
    }

    if (!workRecord.subject) {
      if (!subjectTextBoxRef.current.props.disabled) {
        subjectTextBoxRef.current.instance.option(
          "validationStatus",
          "invalid"
        );

        return;
      }
    }

    setPopupVisible(false);

    const data = {
      ...appointmentData,
      ...workRecord,
      startDate: appointmentData.startDate,
      contrNo: Array.isArray(workRecord.contrNo)
        ? workRecord.contrNo[0]
        : workRecord.contrNo,
      codeNo: Array.isArray(workRecord.codeNo)
        ? workRecord.codeNo[0]
        : workRecord.codeNo,
      descr: descriptionRef.current.instance.option("value"),
      // employeeNo: userInfo.employeeNo,
      // employeeNo: currentEmployeeNo,
      employeeNo: currentEmployee.employeeNo,
    };

    if (appointmentData.id) {
      if (appointmentData.copy) {
        schedulerRef.current.instance.addAppointment(data);
      } else {
        schedulerRef.current.instance.updateAppointment(appointmentData, data);
      }
    } else {
      schedulerRef.current.instance.addAppointment(data);
    }

    // descriptionRef.current.instance.option("value", null);

    // dispatch(
    //   updateWorkRecord({
    //     classifWork: null,
    //     contrNo: null,
    //     codeNo: null,
    //     SEQ: null,
    //     subject: null,
    //     descr: null,
    //     startDate: null,
    //   })
    // );
    descriptionRef.current.instance.reset();

    taskDropDownBoxRef.current.instance.reset();
  };

  const contentRender = (props) => {
    return (
      <div>
        <ScheduleForm
          appointmentData={appointmentData}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
        <hr color="#e0e0e0" />
        <WorkRecordForm
          // workRecordRef={workRecordRef}
          classifWorkSelectBoxRef={classifWorkSelectBoxRef}
          projectDropDownBoxRef={projectDropDownBoxRef}
          taskDropDownBoxRef={taskDropDownBoxRef}
          detailedTaskDropDownBoxRef={detailedTaskDropDownBoxRef}
          subjectTextBoxRef={subjectTextBoxRef}
          descriptionRef={descriptionRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
        {/* {userInfo.employeeNo == currentEmployeeNo && ( */}
        {userInfo.employeeNo == currentEmployee.employeeNo && (
          <Button
            width={100}
            text={appointmentData && appointmentData.copy ? "Paste" : "Done"}
            type="success"
            stylingMode="contained"
            onClick={onClick}
          />
        )}
      </div>
    );
  };

  const onHiding = (e) => {
    setPopupVisible(false);
  };

  const onHidden = (e) => {
    // setPopupVisible(false);
    // setAppointmentData({});

    dispatch(
      updateWorkRecord({
        classifWork: null,
        contrNo: null,
        quotNo: null,
        codeNo: null,
        SEQ: null,
        subject: null,
        descr: null,
        startDate: null,
      })
    );

    // if (descriptionRef.current) {
    //   descriptionRef.current.instance.option("value", null);
    // }
  };

  const onClickCopy = () => {
    const duration =
      new Date(appointmentData.endDate) - new Date(appointmentData.startDate);

    setAppointmentData({
      ...appointmentData,
      startDate: new Date(),
      endDate: new Date().getTime() + duration,
      copy: true,
    });
  };

  return (
    <React.Fragment>
      {/* {userInfo.resp && (
        <SelectBox
          dataSource={employeeDataSource}
          // defaultValue={userInfo.employeeNo}
          defaultValue={currentEmployeeNo}
          displayExpr={displayExpr}
          onValueChanged={onValueChanged}
        />
      )} */}
      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            WORKING TIMETABLE
          </span>
        </Item>
        {canSeeMgrTab && (
          <Item location="after">
            <SelectBox
              dataSource={employeeDataSource}
              // defaultValue={userInfo.employeeNo}
              // defaultValue={currentEmployeeNo}
              defaultValue={currentEmployee.employeeNo}
              displayExpr={displayExpr}
              onValueChanged={onValueChanged}
              width={180}
              grouped={true}
            />
          </Item>
        )}
      </Toolbar>
      <Scheduler
        id="scheduler"
        ref={schedulerRef}
        dataSource={dataSource}
        // views={["day", "week", "workWeek", "month"]}
        defaultCurrentView="week"
        // currentDate={new Date()}
        firstDayOfWeek={0}
        showAllDayPanel={false}
        height={"100%"}
        dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
        startDayHour={7}
        textExpr={"subject"}
        // adaptivityEnabled={true}
        appointmentRender={appointmentRender}
        // appointmentTooltipRender={appointmentTooltipRender}
        shadeUntilCurrentTime={true}
        editing={
          // userInfo.employeeNo == currentEmployeeNo
          userInfo.employeeNo == currentEmployee.employeeNo
            ? {
                allowAdding: true,
                allowDeleting: true,
                allowResizing: true,
                allowDragging: true,
                allowUpdating: true,
              }
            : {
                allowAdding: false,
                allowDeleting: false,
                allowResizing: false,
                allowDragging: false,
                allowUpdating: false,
              }
        }
        timeCellComponent={TimeCell}
        dataCellComponent={DataCell}
        onAppointmentFormOpening={onAppointmentFormOpening}
      >
        <View type="day" startDayHour={0} endDayHour={24} />
        <View
          type="week"
          startDayHour={7}
          endDayHour={24}
          // maxAppointmentsPerCell={1}
        />
        <View type={"workWeek"} startDayHour={7} endDayHour={24} />
        <View type="month" />

        {resourceDataSource && (
          <Resource
            dataSource={resourceDataSource}
            fieldExpr="contrNo"
            label="ContrNo"
            useColorAsDefault={true}
          />
        )}
      </Scheduler>
      <Popup
        visible={popupVisible}
        width={1200}
        // height={750}
        height={650}
        hideOnOutsideClick={false}
        onHiding={onHiding}
        onHidden={onHidden}
        dragEnabled={false}
        showCloseButton={true}
        title={
          appointmentData && appointmentData.copy
            ? "Work Record (Copy)"
            : "Work Record"
        }
        contentRender={contentRender}
      >
        {appointmentData &&
          appointmentData.id &&
          !appointmentData.copy &&
          userInfo.employeeNo == currentEmployee.employeeNo && (
            <ToolbarItem
              widget={"dxButton"}
              location="after"
              options={{ text: "Copy", onClick: onClickCopy }}
            />
          )}
      </Popup>
    </React.Fragment>
  );
}
